export default {
  "content": "<path fill=\"#EFFAFD\" d=\"M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20z\"/><path fill=\"#028EB7\" d=\"M15 28h-2a1 1 0 01-1-1v-8a1 1 0 011-1h2a1 1 0 011 1v8a1 1 0 01-1 1zm6 0h-2a1 1 0 01-1-1V13a1 1 0 011-1h2a1 1 0 011 1v14a1 1 0 01-1 1zm6 0h-2a1 1 0 01-1-1V16a1 1 0 011-1h2a1 1 0 011 1v11a1 1 0 01-1 1z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "40",
    "height": "40",
    "fill": "none"
  }
};